<template>
  <div class="chart1">
    <div class="box2_tuli1">
      <div>
        均线<i style="font-style: normal; color: #fcad2a; margin-left: 10px"
          >MA5:{{ data5 }}</i
        ><i style="font-style: normal; color: #579fff; margin-left: 10px"
          >MA10:{{ data6 }}</i
        ><i style="font-style: normal; color: #c515a8; margin-left: 10px"
          >MA20:{{ data7 }}</i
        >
      </div>
    </div>
    <div class="box2_tuli2">
      <div>
        <i style="font-style: normal; color: #fcad2a; margin-left: 10px"
          >VOL:{{ data8 }}</i
        ><i style="font-style: normal; color: #579fff; margin-left: 10px"
          >MA5:{{ data9 }}</i
        ><i style="font-style: normal; color: #c515a8; margin-left: 10px"
          >MA10:{{ data10 }}</i
        >
      </div>
    </div>
    <div id="Chart1" style="width: 100%; height: 310px"></div>
  </div>
</template>

<script>
export default {
  props:{
    chart1_data_volumes:{
      type:Array,
      default(){
        return []
      }
    },
    chart1_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart1_data_y:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data() {
    return {
      volumes: [],
      colorList: [
        "#c23531",
        "#2f4554",
        "#61a0a8",
        "#d48265",
        "#91c7ae",
        "#749f83",
        "#ca8622",
        "#bda29a",
        "#6e7074",
        "#546570",
        "#c4ccd3",
      ],
      index: 0, //index
      data1: 0, //开盘价
      data2: 0, //收盘价
      data3: 0, //最低价
      data4: 0, //最高价
      data5: 0, //MA5
      data6: 0, //MA10
      data7: 0, //MA20
      data8: 0, //量
      data9:0,  //volma5
      data10:0,  //volma10
    };
  },
  computed: {
    dataMA5() {
      return this.calculateMA(5, this.chart1_data_y);
    },
    dataMA10() {
      return this.calculateMA(10, this.chart1_data_y);
    },
    dataMA20() {
      return this.calculateMA(20, this.chart1_data_y);
    },
    volumesMA5() {
      return this.calculateMA2(5, this.volumes);
    },
    volumesMA10() {
      return this.calculateMA2(10, this.volumes);
    },
  },
  methods: {
    calculateMA(dayCount, data) {
      let result = [];
      for (let i = 0, len = data.length; i < len; i++) {
        if (i < (dayCount - 1)) {
          result.push("-");
          continue;
        }
        let sum = 0;
        for (let j = 0; j < dayCount; j++) {
          sum += +data[i - j][1];
        }
        result.push((sum / dayCount).toFixed(2));
      }
      return result;
    },
    calculateMA2(dayCount, data) {
      let result = [];
      for (let i = 0, len = data.length; i < len; i++) {
        if (i < (dayCount - 1)) {
          result.push("-");
          continue;
        }
        let sum = 0;
        for (let j = 0; j < dayCount; j++) {
          sum += +data[i - j].value;
        }
        result.push((sum / dayCount).toFixed(2));
      }
      return result;
    },
    myEcharts() {
      let that = this;
      var myChart = this.$echarts.init(document.getElementById("Chart1"));
      //配置图表
      var option = {
        animation: false, //是否开启动画
        color: [
          "#c23531",
          "#2f4554",
          "#61a0a8",
          "#d48265",
          "#91c7ae",
          "#749f83",
          "#ca8622",
          "#bda29a",
          "#6e7074",
          "#546570",
          "#c4ccd3",
        ],
        tooltip: {
          show: true,
          axisPointer: {
            type: "cross",
          },
          triggerOn: "mousemove", //提示框触发条件   mousemove 鼠标移动  click 鼠标点击  mousemove|click 同时鼠标移动和点击时触发   none 需手动触发
          transitionDuration: 0, //提示框浮层的移动动画过渡时间，单位是 s，设置为 0 的时候会紧跟着鼠标移动。
          confine: true, //是否将 tooltip 框限制在图表的区域内
          // borderRadius: 4,
          borderWidth: 1, //提示框浮层的边框宽
          borderColor: "#333", //提示框浮层的边框颜色
          backgroundColor: "rgba(255,255,255,0.9)", //提示框浮层的背景颜色
          textStyle: {
            fontSize: 12,
            color: "#333",
          }, //提示框字体样式
          trigger: "axis",

          formatter: function (params) {
            var result = "时间：" + params[0].name + "<br/>";
            params.forEach(function (item) {
              if (item.seriesName == "日K") {
                let canshu1 = item.value.toString().split(",")[1];
                that.data1 = canshu1;
                let canshu2 = item.value.toString().split(",")[2];
                that.data2 = canshu2;
                let canshu3 = item.value.toString().split(",")[3];
                that.data3 = canshu3;
                let canshu4 = item.value.toString().split(",")[4];
                that.data4 = canshu4;
                result +=
                  "开盘价：" +
                  canshu1 +
                  "</br>" +
                  "收盘价：" +
                  canshu2 +
                  "</br>" +
                  "最低价：" +
                  canshu3 +
                  "</br>" +
                  "最高价：" +
                  canshu4 +
                  "</br>";
              } else {
                result +=
                  item.seriesName +
                  "：" +
                  item.value.toString().substring(0, 7) +
                  "</br>";

                if (item.seriesName == "MA5") {
                  that.data5 = item.value;
                } else if (item.seriesName == "MA10") {
                  that.data6 = item.value;
                } else if (item.seriesName == "MA20") {
                  that.data7 = item.value;
                } else if (item.seriesName == "量") {
                  that.data8 = item.value;
                }else if (item.seriesName == "VOLMA5") {
                  that.data9 = item.value;
                }else if (item.seriesName == "VOLMA10") {
                  that.data10 = item.value;
                }
              }
            });
            return result;
          },
        },
        axisPointer: {
          link: { xAxisIndex: "all" },
          label: {
            backgroundColor: "#777",
          },
        },
        dataZoom: [
          {
            type: "inside",
            xAxisIndex: [0, 1], //表示这个 dataZoom 组件控制 第一个 和 第二个 xAxis
          },
          {
            type: "inside",
            xAxisIndex: [0, 1],
          },
        ],
        xAxis: [
          {
            show: false,
            type: "category",
            data: this.chart1_data_x,
            boundaryGap: true,
            axisLabel: {
              formatter: function (value) {
                return value;
              },
            },
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              show: true,
              label: {
                show: false,
              },
              z: 100,
            },
          },
          {
            type: "category",
            gridIndex: 1,
            data: this.chart1_data_x,
            boundaryGap: true,
            splitLine: { show: false },
            axisLabel: {
              show: true,
              formatter: function (value) {
                return value
              },
            },
            axisTick: { show: false },
            min: "dataMin",
            max: "dataMax",
            axisPointer: {
              show: true,
              z: 100,
            },
          },
        ],
        yAxis: [
          {
            scale: true,
            splitNumber: 2,
            axisTick: { show: false },
            axisLabel: {
              inside: true,
              formatter: "{value}",
            },
          },
          {
            scale: true,
            gridIndex: 1,
            splitNumber: 2,
            axisLabel: { show: false },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
          },
        ],
        grid: [
          {
            left: 0,
            right: 0,
            top: 10,
            bottom: 160,
          },
          {
            left: 0,
            right: 0,
            top: 180,
            bottom: 20,
          },
        ],
        graphic: [
          {
            type: "group",
            left: "center",
            top: 70,
            width: 300,
            bounding: "raw",
            children: [
              {
                id: "MA5",
                type: "text",
                style: { fill: this.colorList[1], font: this.labelFont },
                left: 0,
              },
              {
                id: "MA10",
                type: "text",
                style: { fill: this.colorList[2], font: this.labelFont },
                left: "center",
              },
              {
                id: "MA20",
                type: "text",
                style: { fill: this.colorList[3], font: this.labelFont },
                right: 0,
              },
            ],
          },
          {
            type: "group",
            left: "center",
            bottom: 70,
            width: 300,
            bounding: "raw",
            children: [
              {
                id: "VOLMA5",
                type: "text",
                style: { fill: this.colorList[1], font: this.labelFont },
                left: 0,
              },
              {
                id: "VOLMA10",
                type: "text",
                style: { fill: this.colorList[2], font: this.labelFont },
                left: "center",
              },
            ],
          },
        ],
        series: [
          {
            name: "量",
            type: "bar",
            xAxisIndex: 1,
            yAxisIndex: 1,
            data: this.volumes,
            symbol: "none",
          },
          {
            type: "candlestick",
            name: "日K",
            data: this.chart1_data_y,
            symbol: "none",
          },
          {
            name: "MA5",
            type: "line",
            data: this.dataMA5,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#fcad2a",
            },
            symbol: "none",
          },
          {
            name: "MA10",
            type: "line",
            data: this.dataMA10,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#579fff",
            },
            symbol: "none",
          },
          {
            name: "MA20",
            type: "line",
            data: this.dataMA20,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#c515a8",
            },
            symbol: "none",
          },
          {
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: "VOLMA5",
            type: "line",
            data: this.volumesMA5,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#579fff",
            },
            symbol: "none",
          },
          {
            xAxisIndex: 1,
            yAxisIndex: 1,
            name: "VOLMA10",
            type: "line",
            data: this.volumesMA10,
            smooth: true,
            showSymbol: false,
            lineStyle: {
              width: 1,
              color: "#c515a8",
            },
            symbol: "none",
          },
        ],
      };
      myChart.setOption(option);
    },
    init(){
      this.volumes = this.chart1_data_volumes
      this.volumes = this.volumes.map((ele, index) => {
        let canshu1 = this.chart1_data_y[index][1] - this.chart1_data_y[index][0];
        if (canshu1 > 0) {
          ele = {
            value: ele,
            itemStyle: {
              color: "#fd4c4c",
            },
          };
        } else {
          ele = {
            value: ele,
            itemStyle: {
              color: "#3cbb73",
            },
          };
        }
        return ele;
      });
      setTimeout(() => {
        console.log(this.volumes);
       this.myEcharts(); 
      });
    }
  },
  mounted() {
    // this.init()
  },
};
</script>

<style scoped>
.box2_tuli1 {
  font-size: 12px;
  /* padding-left: 20px; */
  margin-bottom: 10px;
}
.chart1 {
  position: relative;
}
.box2_tuli2 {
  position: absolute;
  left: 0;
  top: 185px;
  z-index: 999;
  font-size: 12px;
}
</style>